import { jsPDF } from 'jspdf';
import { getCurrencySymbol } from './currency';

export const generateContract = (contractData) => {
  const { project, client, freelancer } = contractData;
  const currencySymbol = getCurrencySymbol(freelancer.currency);
  
  const doc = new jsPDF();
  
  // Title
  doc.setFontSize(20);
  doc.setTextColor(79, 70, 229);
  doc.text('SERVICE AGREEMENT CONTRACT', 105, 20, { align: 'center' });
  
  // Date
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 35);
  
  // Parties
  let yPos = 50;
  doc.setFontSize(12);
  doc.text('BETWEEN:', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.text('Service Provider (Freelancer):', 20, yPos);
  yPos += 7;
  doc.text(`Name: ${freelancer.name}`, 25, yPos);
  yPos += 7;
  doc.text(`Email: ${freelancer.email}`, 25, yPos);
  yPos += 15;
  
  doc.text('AND', 20, yPos);
  yPos += 10;
  
  doc.text('Client:', 20, yPos);
  yPos += 7;
  doc.text(`Name: ${client.name}`, 25, yPos);
  yPos += 7;
  if (client.company) {
    doc.text(`Company: ${client.company}`, 25, yPos);
    yPos += 7;
  }
  doc.text(`Email: ${client.email}`, 25, yPos);
  yPos += 15;
  
  // Terms
  doc.setFontSize(12);
  doc.setTextColor(79, 70, 229);
  doc.text('TERMS AND CONDITIONS', 20, yPos);
  yPos += 10;
  
  // 1. Project Description
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('1. Project Description', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  const projectDesc = doc.splitTextToSize(
    `Project Title: ${project.title}\n${project.description}`,
    170
  );
  doc.text(projectDesc, 25, yPos);
  yPos += (projectDesc.length * 7) + 10;
  
  // 2. Compensation
  doc.setFontSize(11);
  doc.text('2. Compensation', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  doc.text(`Total Project Fee: ${currencySymbol}${project.total_budget.toFixed(2)}`, 25, yPos);
  yPos += 7;
  doc.text('Payment Terms: As per agreed milestones', 25, yPos);
  yPos += 15;
  
  // 3. Timeline
  doc.setFontSize(11);
  doc.text('3. Project Timeline', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  if (project.start_date) {
    doc.text(`Start Date: ${project.start_date}`, 25, yPos);
    yPos += 7;
  }
  if (project.end_date) {
    doc.text(`Expected Completion: ${project.end_date}`, 25, yPos);
    yPos += 7;
  }
  yPos += 10;
  
  // 4. Deliverables
  doc.setFontSize(11);
  doc.text('4. Deliverables', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  doc.text('• Complete project as per agreed specifications', 25, yPos);
  yPos += 7;
  doc.text('• Source code and documentation', 25, yPos);
  yPos += 7;
  doc.text('• Support during warranty period', 25, yPos);
  yPos += 15;
  
  // New page if needed
  if (yPos > 230) {
    doc.addPage();
    yPos = 20;
  }
  
  // 5. Intellectual Property
  doc.setFontSize(11);
  doc.text('5. Intellectual Property Rights', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  const ipText = doc.splitTextToSize(
    'Upon full payment, all intellectual property rights for the deliverables shall be transferred to the Client.',
    170
  );
  doc.text(ipText, 25, yPos);
  yPos += (ipText.length * 7) + 10;
  
  // 6. Confidentiality
  doc.setFontSize(11);
  doc.text('6. Confidentiality', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  const confText = doc.splitTextToSize(
    'Both parties agree to keep all project information confidential and not disclose it to third parties without consent.',
    170
  );
  doc.text(confText, 25, yPos);
  yPos += (confText.length * 7) + 10;
  
  // 7. Termination
  doc.setFontSize(11);
  doc.text('7. Termination', 20, yPos);
  yPos += 7;
  doc.setFontSize(10);
  const termText = doc.splitTextToSize(
    'Either party may terminate this agreement with 15 days written notice. Client shall pay for work completed up to termination date.',
    170
  );
  doc.text(termText, 25, yPos);
  yPos += (termText.length * 7) + 20;
  
  // Signatures
  if (yPos > 200) {
    doc.addPage();
    yPos = 20;
  }
  
  doc.setFontSize(11);
  doc.text('SIGNATURES', 20, yPos);
  yPos += 15;
  
  doc.setFontSize(10);
  doc.text('Service Provider:', 20, yPos);
  doc.text('Client:', 120, yPos);
  yPos += 20;
  
  doc.line(20, yPos, 80, yPos); // Signature line
  doc.line(120, yPos, 180, yPos); // Signature line
  yPos += 7;
  
  doc.text(freelancer.name, 20, yPos);
  doc.text(client.name, 120, yPos);
  yPos += 7;
  
  doc.text(`Date: _____________`, 20, yPos);
  doc.text(`Date: _____________`, 120, yPos);
  
  return doc;
};

export const downloadContract = (contractData, filename) => {
  const doc = generateContract(contractData);
  doc.save(filename || `Contract_${contractData.project.title.replace(/\s+/g, '_')}.pdf`);
};
